import React, { Component } from 'react'

import { connect, batch } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, Typography, TextField } from '@material-ui/core';


import { withRouter } from 'react-router';
import { getLocationPathName } from '../../selectors/util.selector';
import { DatePicker, DateTimePicker } from "material-ui-pickers";
import moment, { Moment } from 'moment'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { isSetPullDateDialogDialogOpen } from '../../selectors/phaseplan.selector';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { dialogActions } from '../../actions/dialog.actions';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { lookaheadActions } from '../../actions/lookahead.actions';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import { Variance, VarianceToEnglish } from '../../utils/Variance';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PullOrPush } from '../../utils/PullOrPush';
import { phasePlanActions } from '../../actions/phaseplan.actions';
import { isRowCountDialogOpen, rowCountRow } from '../../selectors/dialog.selector';
import { CirclePicker } from 'react-color';
import { getOldRowCountData } from '../../selectors/lookahead.selector';

interface Props {
    isRowCountDialogOpen: boolean;
    closeDialogValue: () => void;
    changeGroupSetting: (row: number, name: string, color: string) => void;
    classes: ClassNameMap,
    rowCountRow: number,
    oldData: RowGroup
}

type GroupInfo = {
    name: string,
    color: string
}

type State = {
    groupInfo: GroupInfo;
}


class _RowCountDialog extends Component<Props, State> {

    state = {
        groupInfo: {
            name: '',
            color: '#000'
        }
    }


    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    onConfirm = () => {
        const { closeDialogValue, changeGroupSetting, rowCountRow } = this.props
        const { groupInfo } = this.state
        changeGroupSetting(rowCountRow, groupInfo.name, groupInfo.color)
        closeDialogValue()
    }

    onColorChange = async(value:any) => {
        const groupInfo = { ...this.state.groupInfo }
        groupInfo.color = value.hex
    
        this.setState({
            groupInfo
        })
    }

    onNameChange = async (event: any) => {
        const groupInfo = { ...this.state.groupInfo }
        
        groupInfo.name = event.target.value

        this.setState({
            groupInfo
        });
    }

    onEnter = () => {
        const { oldData } = this.props
        this.setState({
            groupInfo:{
                name: !!oldData ? oldData.name : '',
                color: !!oldData ? oldData.color : ''
            }
        })
    }

    
    

    render() {
        const { classes, isRowCountDialogOpen } = this.props;
        const { groupInfo } = this.state
        return (
            <Dialog
                onEnter={this.onEnter}
                maxWidth='sm'
                fullWidth={true}
                open={!!isRowCountDialogOpen}
                
            >
                <DialogContent>
                    <div style={{backgroundColor: groupInfo.color}} className={classes.DialogFormTitle}>
                        <p className={classes.DialogFormTitleText}>
                            Group
                        </p>
                    </div>
                    <div className={classes.DialogFormContent} >
                    <div className={classes.DialogFormField}>
                        <p className={classes.DialogFormLabel}>Name*</p>
                        <TextField
                            disabled={false}
                            required={true}
                            value={!!groupInfo.name ? groupInfo.name : ""}
                            onChange={this.onNameChange}
                            fullWidth={true}
                        />
                    </div>
                    <CirclePicker 
                        color={ groupInfo.color }
                        onChangeComplete={ this.onColorChange } />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                    <Button onClick={this.onConfirm}  color="primary"> Confirm </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state:any) => ({
    isRowCountDialogOpen: isRowCountDialogOpen(state),
    rowCountRow: rowCountRow(state),
    oldData: getOldRowCountData(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(dialogActions.closedRowCountDialog()),
        changeGroupSetting: (row: number, name: string, color: string) => dispatch(lookaheadActions.changeGroupSetting(row, name, color))
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)(_RowCountDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/RowCountDialog.tsx